export default __webpack_public_path__ + "static/media/profilephoto.19cc0d41.jpg";